// F14 — NY-local date helpers.
//
// NexSav operates in America/New_York. Rendering the *UTC* calendar date of a
// timestamp (the old `String(iso).slice(0, 10)` pattern) is off-by-one in the
// NY evening: after ~8pm ET the UTC date has already rolled over to tomorrow.
// These helpers collapse a timestamp to its NY-local calendar day instead.
//
// NOTE: do NOT use these on date-only ('YYYY-MM-DD') values like task due_dates
// — those carry no time/zone and must be shown verbatim. Use these only on real
// timestamps (ISO datetimes) and for "today" comparisons.

const NY_TZ = 'America/New_York';

// Timestamp → 'YYYY-MM-DD' in NY-local time. Returns '' for empty/invalid input.
export function nyDateKey(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.valueOf())) return '';
  // 'en-CA' formats as YYYY-MM-DD.
  return d.toLocaleDateString('en-CA', { timeZone: NY_TZ });
}

// Today's 'YYYY-MM-DD' in NY-local time. Use for "due today" comparisons so the
// baseline matches how date-only due dates are entered (NY calendar days).
export function nyToday() {
  return new Date().toLocaleDateString('en-CA', { timeZone: NY_TZ });
}
